import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function ProofSection() {
  return <section className="py-12 md:py-24 px-4 bg-forest-900 text-cream-100 relative overflow-hidden" data-id="element-137">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-forest-950/50" data-id="element-138"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex justify-center mb-8" data-id="element-140">
          <div className="p-4 rounded-full bg-amber-500/10 text-amber-500 border border-amber-500/30" data-id="element-141">
            <Shield size={40} strokeWidth={1.5} data-id="element-142" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-4 md:space-y-8" data-id="element-143">
          <p className="text-2xl md:text-3xl font-playfair leading-relaxed text-cream-100/90 font-medium" data-id="element-144">
            "En solo 7 días, dejarás de correr a la farmacia por malestares
            menores."
          </p>

          <div className="w-16 h-px bg-amber-500/50 mx-auto" data-id="element-145"></div>

          <p className="text-lg md:text-xl font-lora text-cream-200/80 leading-relaxed italic" data-id="element-146">
            Sentirás la diferencia de un sistema digestivo desinflamado y una
            mente clara, usando ingredientes que hoy usas solo para sazonar la
            carne.
          </p>
        </motion.div>
      </div>
    </section>;
}